import { render, staticRenderFns } from "./productModal.vue?vue&type=template&id=1cced9f4&"
import script from "./productModal.vue?vue&type=script&lang=js&"
export * from "./productModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports